import { RefObject, useLayoutEffect, useState } from 'react';

export default function useHasOverflow(
  ref: RefObject<HTMLDivElement>,
): boolean {
  const [hasOverflow, setHasOverflow] = useState(false);

  useLayoutEffect(() => {
    const { current } = ref;

    if (!current) return;

    const overflow =
      current.scrollHeight > current.clientHeight ||
      (!!current.parentElement &&
        current.parentElement.scrollHeight >
          current.parentElement.clientHeight);

    setHasOverflow(overflow);
  }, [ref]);

  return hasOverflow;
}
